/**
 * Generated runtime TestId mirror for frontend/src/features/outbound-connectors/components/LdapProvisioningConfigEditor.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const LdapProvisioningConfigEditorTestIds = {
  btnAddOuRule: "btn-add-ou-rule",
  btnLdapCancel: "btn-ldap-cancel",
  btnLdapSave: "btn-ldap-save",
  cardTitleLdapProvisioningConfig: "card-title-ldap-provisioning-config",
  colOuActions: "col-ou-actions",
  colOuAttribute: "col-ou-attribute",
  colOuAttributeReadonly: "col-ou-attribute-readonly",
  colOuOperator: "col-ou-operator",
  colOuOperatorReadonly: "col-ou-operator-readonly",
  colOuTarget: "col-ou-target",
  colOuTargetReadonly: "col-ou-target-readonly",
  colOuValue: "col-ou-value",
  colOuValueReadonly: "col-ou-value-readonly",
  defaultOuError: "default-ou-error",
  dnTemplateError: "dn-template-error",
  ldapDefaultOu: "ldap-default-ou",
  ldapDirtyActions: "ldap-dirty-actions",
  ldapDnTemplate: "ldap-dn-template",
  ldapProvisioningConfigCard: "ldap-provisioning-config-card",
  ldapProvisioningConfigLoading: "ldap-provisioning-config-loading",
  objectClasses: "object-classes",
  ouRulesReadonlyTable: "ou-rules-readonly-table",
  ouRulesTable: "ou-rules-table",
  ouRuleAttribute: (index: number) => `ou-rule-attribute-${index}`,
  ouRuleAttributePrefix: () => "ou-rule-attribute-" as TestIdPrefix,
  ouRuleDelete: (index: number) => `ou-rule-delete-${index}`,
  ouRuleDeletePrefix: () => "ou-rule-delete-" as TestIdPrefix,
  ouRuleOperator: (index: number) => `ou-rule-operator-${index}`,
  ouRuleOperatorPrefix: () => "ou-rule-operator-" as TestIdPrefix,
  ouRuleRow: (index: number) => `ou-rule-row-${index}`,
  ouRuleRowPrefix: () => "ou-rule-row-" as TestIdPrefix,
  ouRuleTargetOu: (index: number) => `ou-rule-target-ou-${index}`,
  ouRuleTargetOuPrefix: () => "ou-rule-target-ou-" as TestIdPrefix,
  ouRuleValue: (index: number) => `ou-rule-value-${index}`,
  ouRuleValuePrefix: () => "ou-rule-value-" as TestIdPrefix,
  ouRuleValueTags: (index: number) => `ou-rule-value-tags-${index}`,
  ouRuleValueTagsPrefix: () => "ou-rule-value-tags-" as TestIdPrefix
} as const;
